import Api from "./Api";
import ApiNode from "./ApiNode";


export default {
    getAllTrasportList(payload) {
        let AllTransportationList = Api().post(
            "Api_Transport/getTransportation.php",
            payload
        );
        return AllTransportationList;
    },

    getAllGRN_List(payload) {
        let allGRN_List = Api().post(
            "Api_Transport/fetchGRN-List.php",
            payload
        );
        return allGRN_List;
    },

    getGRNListNew(payload, config) {
        let allGRN_List = ApiNode().post(
            "get-common-job/get-grn-list",
            payload,
            config
        );
        return allGRN_List;
    },

    getOfRateList(payload, config) {
        let allGRN_List = ApiNode().post(
            "get-common-job/get-rate-job-list",
            payload,
            config
        );
        return allGRN_List;
    },

    getSubscriptionTrack(payload, config) {
        let getTrack = ApiNode().post("trannsport/track", payload, config);
        return getTrack;
    },

    getTimeLineSubscriptionTrack(payload, config) {
        let getTrack = ApiNode().post("trannsport/track/time-line", payload, config);
        return getTrack;
    },

    getMilestoneSubscriptionTrack(payload, config) {
        let getTrack = ApiNode().post("trannsport/track/milestone-tracking", payload, config);
        return getTrack;
    },
};



// WEBPACK FOOTER //
// ./src/services/TrasportService.js